import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";

const Resume = () => {
  const navigate = useNavigate();
  const backHome = () => {
    navigate("/");
  };

  return (
    <div className="bg-[#111] text-white min-h-screen w-full px-4 py-16" style={{ fontFamily: "Poppins, sans-serif" }}>
      {/* Close Button */}
      <div className="absolute right-6 top-4 md:right-14 md:top-7">
        <button
          onClick={backHome}
          className="relative after:absolute after:right-1 after:top-1 after:h-4/5 after:w-4/5 after:animate-ping after:rounded-full after:border-2 after:border-[#009e66] after:ease-out"
        >
          <CloseIcon sx={{ fontSize: "38px", color: "#009e66" }} />
        </button>
      </div>

      {/* Heading */}
      <div className="text-center mb-10">
        <p className="text-[#9f9f9f] text-sm">Check out my Resume</p>
        <h1 className="text-4xl md:text-5xl font-bold mt-2">Resume</h1>
      </div>

      {/* Grid Container */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 max-w-7xl mx-auto">
        {/* Education Section */}
        <div className="flex flex-col gap-6">
          <h2 className="text-2xl text-[#009e66]">Education</h2>

          {[
            {
              title: "University Of Barishal",
              time: "(Feb'01'2023 - Present)",
              location: "Barishal, Bangladesh",
              details: "B.Sc in Computer Science & Engineering",
            },
            {
              title: "Barguna Govt College",
              time: "(Apr'18'2019 - Feb'20'2021)",
              location: "Barguna, Barishal",
              details: "Intermediate - Science (GPA: 5.00)",
            },
            {
              title: "Gaurichanna N. S. Secondary School",
              time: "(Mar'08'2014 - Jan'18'2019)",
              location: "Barguna, Barishal",
              details: "High School - Science (GPA: 5.00)",
            },
          ].map((edu, idx) => (
            <div
              key={idx}
              className="bg-[#161616] border-l-2 border-[#009e66] rounded-lg p-6 transition-all duration-300 hover:shadow-glow w-full"
            >
              <h3 className="text-xl font-semibold">{edu.title}</h3>
              <p className="text-[#9f9f9f] text-sm mt-1">
                {edu.location} <span className="ml-1 text-xs">{edu.time}</span>
              </p>
              <p className="text-[#9f9f9f] text-sm mt-1">{edu.details}</p>
            </div>
          ))}
        </div>

        {/* Experience Section */}
        <div className="flex flex-col gap-6">
          <h2 className="text-2xl text-[#009e66]">Experience</h2>

          <div className="bg-[#161616] border-l-2 border-[#009e66] rounded-lg p-6 transition-all duration-300 hover:shadow-glow w-full">
            <h3 className="text-xl font-semibold text-white">Full Stack Developer (Full-Time, Remote)</h3>
            <p className="text-[#9f9f9f] text-base mt-1">RixoTech | January 2025 – Present</p>
            <ul className="list-disc list-inside text-[#9f9f9f] text-sm mt-2 space-y-1">
              <li>Developing and maintaining front-end features using React, Next.js, and TailwindCSS.</li>
              <li>Collaborating with designers and backend developers to ensure performance and responsiveness.</li>
              <li>Using Docker, Turborepo, and Monorepo for scalable architecture and efficient dev workflow.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Resume;
